import { render, staticRenderFns } from "./tabbarCom.vue?vue&type=template&id=b25eec3a&scoped=true&"
import script from "./tabbarCom.vue?vue&type=script&lang=js&"
export * from "./tabbarCom.vue?vue&type=script&lang=js&"
import style0 from "./tabbarCom.vue?vue&type=style&index=0&id=b25eec3a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b25eec3a",
  null
  
)

export default component.exports